import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { get } from 'lodash'
import {
  Text,
  StackChildren,
  Colors,
  Inline,
  Stack,
} from '@doordash/design-language'
import Button from '@doordash/component-button'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { BASE_GROWTH_IMAGE_CDN, FIRST_DASH_PATH } from '../../../constants'
import { SplashImageContainer, ContentContainer } from './styles'
import routes from '../../../routes'
import { FixedBottomContainer } from '../../atoms/fixed-bottom-container/'
import t from './strings'

const splashImageUrl = `${BASE_GROWTH_IMAGE_CDN}${FIRST_DASH_PATH}/splash.png`

type SplashProps = {
  application?: object
  track?: (
    action: DA.EventActions,
    name: DA.ActivatedNoFirstDashScreens,
    data?: object
  ) => Promise<void>
}

export const SplashScreen: React.FC<SplashProps & RouteComponentProps> = ({
  track,
  application,
  history,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.ActivatedNoFirstDashScreens.Splash)
  }, [track])

  const onNavigateToDashPage = () => {
    track(DA.EventActions.Clicked, DA.ActivatedNoFirstDashScreens.Splash, {
      name: 'skip',
      buttonPosition: 'secondary',
    })
    return history.push(routes.firstDashDash.path)
  }

  return (
    <React.Fragment>
      <Stack>
        <SplashImageContainer url={splashImageUrl} />
      </Stack>
      <ContentContainer>
        <Inline>
          <StackChildren>
            <Text styles={Text.Styles.PageTitle1}>
              {t.splash.welcome(get(application, 'firstName', ''))}
            </Text>
            <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
              {t.splash.content1()}
            </Text>
            <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
              {t.splash.content2()}
            </Text>
            <Text styles={Text.Styles.Body1} color={Colors.SystemGrey80}>
              {t.splash.content3()}
            </Text>
          </StackChildren>
        </Inline>
      </ContentContainer>
      <FixedBottomContainer>
        <Stack size={Stack.Sizes.Large}>
          <ContentContainer>
            <Inline>
              <StackChildren size={StackChildren.Sizes.XxSmall}>
                <Button
                  size={Button.Sizes.Large}
                  onClick={() => {
                    track(
                      DA.EventActions.Clicked,
                      DA.ActivatedNoFirstDashScreens.Splash,
                      { name: 'learn', buttonPosition: 'primary' }
                    )
                    history.push(routes.firstDashActivatedNoFirstDash.path)
                  }}
                >
                  {t.splash.primary()}
                </Button>
                <Button
                  onClick={onNavigateToDashPage}
                  size={Button.Sizes.Large}
                  type={Button.Types.Tertiary}
                >
                  {t.splash.secondary()}
                </Button>
              </StackChildren>
            </Inline>
          </ContentContainer>
        </Stack>
      </FixedBottomContainer>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  application: state.application,
})

const mapDispatchToProps = {
  track: events.trackActivatedNoFirstDash,
}

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen)
